


































// Importing components
import LayoutApp from '@/layputs/LayoutApp.vue';
import BaseCard from '@/ui/BaseCard.vue';
import BaseAlertList from '@/ui/BaseAlertList.vue';
import TheFormDiscounts from '@/components/discounts/TheFormDiscounts.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
// Importing functions
import {putDiscount} from '@/ts/discounts/put-discount';
import {getDiscount} from '@/ts/discounts/get-discount';
import {validateDiscount} from '@/ts/discounts/validate-discount';

export default {
    name: 'PageCategoriesUpdate',
    components: {
        LayoutApp,
        BaseCard,
        BaseAlertList,
        TheFormDiscounts,
        BaseLoadingAnimation,
    },
    props: {},
    data() {
        return {
            data: Object(),
            items: Array(),
            errors: Array(),
        };
    },
    methods: {
        onSubmit() {
            this.errors = [];

            validateDiscount(this.errors, this.data);

            if (this.errors.length === 0) {
                this.$store.dispatch('setLoadingOn');
                this.data.from = this.data.from.replace('T', ' ').replace('.000Z', '');
                this.data.to = this.data.to.replace('T', ' ').replace('.000Z', '');

                putDiscount(this.data, this.$route.params.id, this.$route.params.discount_id).then(() => {
                    this.$router.push({ name: 'discounts', params: { id: this.$route.params.id} });
                }).catch(() => {
                    this.data.from.replace(' ', 'T');
                    this.data.from = this.data.from + 'Z';
                    this.data.to.replace(' ', 'T');
                    this.data.to = this.data.to + 'Z';
                });
            }
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Ресторанти',
            to: { path: '/restaurants' },
        }, {
            text: 'Промоции',
            to: { name: 'discounts', params: { id: this.$route.params.id} },
        }, {
            text: 'Редактиране',
        }];
        // Initializing the data object
        this.data = {
            text: '',
            from: '',
            to: '',
        };
        this.$store.dispatch('setLoadingOn');
        // Fetching data from the API
        getDiscount(this.$route.params.discount_id, this.$route.params.id).then((response) => {
            this.data = response;
            this.data.from = this.data.from.date.replace(' ', 'T');
            this.data.from = this.data.from + 'Z';
            this.data.to = this.data.to.date.replace(' ', 'T');
            this.data.to = this.data.to + 'Z';
        }).finally(() => {
            this.$store.dispatch('setLoadingOff');
        });
    },
};
